<div id="ddc-tooltip-icon">
  <ng-container *ngIf="!switchIcon">
    <span class="material-icons" [ngClass]="{'disabled-icon': _iconDisabled === true}" matTooltip="{{_iconText}}" matTooltipClass="ddc-tooltip-icon">{{_icon}}</span>
  </ng-container>

  <ng-container *ngIf="switchIcon && _imgSource === TypeAvisEnum.MARIN && this._camp">
    <span>
      <img class="material-icons marin-icon" [ngClass]="{'disabled-icon': _iconDisabled === true}" matTooltip="{{_iconText}}" matTooltipClass="ddc-tooltip-icon" [src]="getIconMarin(getValidationStatus('avisMarin',_camp)?.classLevel)"  alt="icon"/>
    </span>
  </ng-container>

  <ng-container *ngIf="switchIcon && _imgSource === TypeAvisEnum.MARIN && this._projetAnnee">
    <span>
      <img class="material-icons marin-icon" [ngClass]="{'disabled-icon': _iconDisabled === true}" matTooltip="{{_iconText}}" matTooltipClass="ddc-tooltip-icon" [src]="getIconMarin(getProjetAnneeValidationStatus('avisMarin', _projetAnnee)?.classLevel)"  alt="icon"/>
    </span>
  </ng-container>

  <ng-container *ngIf="switchIcon && _imgSource === TypeAvisEnum.INTERNATIONAL">
    <mat-icon class="material-icons" [class.disabled-icon]="_iconDisabled===true" matTooltip="{{_iconText}}" matTooltipClass="ddc-tooltip-icon" [ngClass]="getValidationStatus('avisInternational', _camp)?.classLevel">
      public
    </mat-icon>
  </ng-container>
</div>
